import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import theme from "./src/theme/lightTheme";
import Layout from "./src/Layouts/Layout";
import createEmotionCache from "./src/createEmotionCache";

const cache = createEmotionCache();

export const wrapRootElement = ({ element }: any) => (
  <CacheProvider value={cache}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>{element}</Layout>
    </ThemeProvider>
  </CacheProvider>
);
